var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import QrcodeVue from 'qrcode.vue';
import { InvoiceData } from "../../../lib/invoiceData";
import WalletBar from '../../parts/WalletBar.vue';
import { getDivided } from "../../../lib/numberUtils";
import { WalletsHelper } from "../../../lib/storage";
export default Vue.extend({
    components: { QrcodeVue, WalletBar },
    name: "InvoiceQR",
    props: {
        amount: {
            type: String,
            default: ''
        },
        rate: {
            type: String,
            default: '0'
        },
    },
    data() {
        return {
            address: '',
            invoiceData: '',
        };
    },
    methods: {
        getXemDescription() {
            return getDivided(Number(this.amount), 6).toString();
        },
        getFiatDescription() {
            return getDivided(Number(this.amount), 6).mul(Number(this.rate)).toString();
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            const activeWallet = yield WalletsHelper.getActive();
            if (activeWallet == null) {
                this.address = '';
            }
            else {
                this.address = activeWallet.address;
            }
            this.invoiceData = new InvoiceData(this.address, Number(this.amount)).toJsonString();
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/qrlab/InvoiceQR.vue
// module id = 649
// module chunks = 1